export const SW_AUTH_SYNC_MESSAGE_TYPE = 'SW_AUTH_SYNC' as const
export const SW_AUTH_CLEAR_MESSAGE_TYPE = 'SW_AUTH_CLEAR' as const

export type SwAuthSyncEpoch = {
  uid: string
  issuedAtMs: number
}

export type SwAuthSyncMessage = {
  type: typeof SW_AUTH_SYNC_MESSAGE_TYPE
  uid?: string
  issuedAtMs?: number
}

export type SwAuthClearMessage = {
  type: typeof SW_AUTH_CLEAR_MESSAGE_TYPE
}

export function isSwAuthSyncEpoch(data: unknown): data is SwAuthSyncEpoch {
  if (typeof data !== 'object' || data === null) return false
  const { uid, issuedAtMs } = data as { uid?: unknown; issuedAtMs?: unknown }
  return typeof uid === 'string' && typeof issuedAtMs === 'number'
}
